import { ErroresLibranzasDictionary } from '../adapters';

/** Mensaje de negocio del ticket 290977 para el caso conocido "empresa sin libranzas". */
export const NIT_SIN_LIBRANZAS_MESSAGE = 'El nit consultado no tiene libranzas pendientes de pago';

interface LibranzasErrorResponseData {
    statusCode?: string;
    userMessage?: string;
}

interface LibranzasAxiosError {
    response?: {
        status?: number;
        data?: LibranzasErrorResponseData;
    };
}

const isLibranzasAxiosError = (error: unknown): error is LibranzasAxiosError =>
    typeof error === 'object' && error !== null && 'response' in error;

/**
 * Resuelve el mensaje a mostrar al usuario ante un error de `consulta-deudores`:
 * 1. HTTP 422 (empresa sin libranzas, estado de negocio conocido): match por
 *    `statusCode` en el diccionario o, si no hay match, el mensaje fijo del ticket.
 * 2. Cualquier otro status: match por `statusCode` en el diccionario.
 * 3. Sin match: `userMessage` que ya entrega el backend.
 * 4. Sin nada de lo anterior (p. ej. error de red sin `response`): `fallback`.
 */
export const resolveLibranzasErrorMessage = (
    dictionary: ErroresLibranzasDictionary,
    error: unknown,
    fallback: string,
): string => {
    if (!isLibranzasAxiosError(error)) return fallback;

    const { status, data } = error.response ?? {};
    const statusCode = data?.statusCode;
    const dictionaryMessage = statusCode ? dictionary[statusCode] : undefined;

    if (status === 422) {
        return dictionaryMessage ?? NIT_SIN_LIBRANZAS_MESSAGE;
    }

    return dictionaryMessage ?? data?.userMessage ?? fallback;
};
